<div class="row" *ngIf="checkViewMode('edit')">



    <label *ngIf="VisiblevalueChange()" class="col-md-12">{{attribute.key}}</label>
  
    <div class="form-group col-md-4 prazo" *ngIf="VisiblevalueChange()">
      <label for="">
        {{start.key}}
        <span class="error-indication" *ngIf="getOptionByKey(start,'required')=='true'">*</span>
        <div *ngIf="getOptionByKey(start,'title')" class="popover-info" 
        [popover]="getOptionByKey(start,'title')"
        placement="right"
        container="body"
        triggers="mouseenter:mouseleave">
          <i class="fa fa-question-circle"></i>
        </div>
      </label>


      <div class="form-group input-datepicker">
        <div class="form-control">
          <i class="fa fa-calendar"></i>
          <ngx-datepicker [(ngModel)]="start.value" (ngModelChange)="onChangeDuration()" [options]="optStat" [class]="'txt_'+getOptionByKey(start,'identifier')"
            [id]="getOptionByKey(start,'identifier')" [tabindex]="getOptionByKey(start,'tabIndex')" [disabled]="disabled ? true : false" (blur)="ngBlurInput(getOptionByKey(start,'identifier'))">
          </ngx-datepicker>
          <i class="fa fa-times" aria-hidden="true" (click)="clearDate()" [hidden]="!date"></i>
        </div> 
        <span [class]="'m-form__error hide has-error-text '+ getOptionByKey(start,'identifier')">{{getOptionByKey(start,'error')}}</span>
      </div>


      
    </div>

    <div class="form-group col-md-4 prazo" *ngIf="VisiblevalueChange()">
      <label for="">
        {{end.key}}
        <span class="error-indication" *ngIf="getOptionByKey(end,'required')=='true'">*</span>
        <div *ngIf="getOptionByKey(end,'title')" class="popover-info" [popover]="getOptionByKey(end,'title')"
        placement="right"
        container="body"
        triggers="mouseenter:mouseleave">
          <i class="fa fa-question-circle"></i>
        </div>
      </label>

      <div class="form-group input-datepicker">
        <div class="form-control">
          <i class="fa fa-calendar"></i>
          <ngx-datepicker [(ngModel)]="end.value" (ngModelChange)="onChangeDuration()" [options]="optEnd" [class]="' txt_'+getOptionByKey(end,'identifier')"
            [id]="getOptionByKey(end,'identifier')" [tabindex]="getOptionByKey(end,'tabIndex')" [disabled]="disabled ? true : false"  (blur)="ngBlurInput(getOptionByKey(end,'identifier'))">
          </ngx-datepicker>
          <i class="fa fa-times" aria-hidden="true" (click)="clearDate()" [hidden]="!date"></i>
        </div> 
        <span [class]="'m-form__error hide has-error-text '+ getOptionByKey(end,'identifier')">{{getOptionByKey(end,'error')}}</span>

      </div>

      
    </div>

    <div class="form-group col-md-4 prazo" *ngIf="VisiblevalueChange()">
      <label for="">
        {{duration.key}}
        <div *ngIf="getOptionByKey(duration,'title')" class="popover-info" [popover]="getOptionByKey(duration,'title')"
        placement="right"
        container="body"
        triggers="mouseenter:mouseleave">
          <i class="fa fa-question-circle"></i>
        </div>
      </label>
      <!-- <div *ngIf="duration.value>0">{{duration.value}} {{duration.value>1?'Dias':duration.value==1?'Dia':''}}</div> -->
    </div>

  <div class="form-group col-md-12" *ngIf="this.getOptionByKey(this.term, 'view') != 'hide'">
    <label for="">
      {{term.key}}
      <div *ngIf="getOptionByKey(term,'title')"   class="popover-info" 
      [popover]="getOptionByKey(term,'title')"
      placement="right"
      container="body"
      triggers="mouseenter:mouseleave">
        <i class="fa fa-question-circle"></i>
      </div>
    </label>
    <div >
      <ui-switch 
        [checked]="ngChecked(getTermValue())" 
        [disabled]="disabled ? true : false"
        (valueChange)="onValueChange($event)"></ui-switch>
    </div>
  </div>
</div>

<div *ngIf="checkViewMode('view')">
  <!-- <label class="col-md-12">{{attribute.key}}</label> -->
  <div class="m-budget" *ngIf="!duration.value"><span _ngcontent-c4="" class="m-budget__desc">{{getTermKey()}}</span></div>
  <div class="m-budget row" *ngIf="duration.value">
    <!-- <span class="m-budget__price m--font-brand">
       {{duration.value}} {{duration.value>1?'Dias':duration.value==1?'Dia':''}}
     </span> 
    <span _ngcontent-c4="" class="m-budget__desc">{{duration.key}} </span> -->
    <!-- <p class="col-md-4"><span>{{duration.key}}: </span> {{duration.value}}
      {{duration.value>1?'Dias':duration.value==1?'Dia':''}}</p> -->

    <p class="col-md-4"><span>{{start.key}}:</span> {{start.value| date}} </p>
    <p class="col-md-4"><span>{{end.key}}:</span> {{end.value| date}} </p>


    <!-- <div class="m-budget--progress row">
      <div class="col-md-6"><p><b>{{start.key}}: </b> {{start.value| date}} </p></div>
      <div class="col-md-6"><p><b>{{end.key}}: </b> {{end.value| date}} </p></div>
    </div> -->
  </div>
</div>